function initPageform() {

    try {
        const field_group = document.querySelector('.fieldgroup.js-expand');
        const expander = field_group.querySelector('.middleColumn.fieldgroup');
        const label = field_group.querySelector('label.left');

        expander.classList.toggle("hide");

        label.addEventListener("click", function () {
            expander.classList.toggle("hide");
        });
    } catch (error) {
        //console.error(error);
    }
}

export default initPageform;
